type AddressPrediction = {
  placeID?: string
  value?: string
  label?: string
  primaryText?: string
  secondaryText?: string
  caption?: string
  address?: string
  name?: string
}

type ResolvedPlace = {
  street_number?: string
  locality?: string
  admin_area_iso_code?: string
  postal_code?: string
  name?: string
}

export const normalizePredictionOption = (item: AddressPrediction = {}) => {
  if (!item) {
    return item
  }

  const placeID = item.placeID || item.value || ''
  const label = item.label || item.primaryText || item.name || ''
  const caption = item.caption || item.secondaryText || item.address || ''

  return {
    ...item,
    placeID,
    label,
    caption,
    primaryText: item.primaryText || label,
    secondaryText: item.secondaryText || caption,
  }
}

export const buildPrefilledDisplayResult = (prefilledValues = '') => {
  const [firstPart] = prefilledValues.split(',')
  const label = prefilledValues.trim()

  return {
    placeID: 'prefilled',
    primaryText: (firstPart || prefilledValues).trim(),
    secondaryText: prefilledValues,
    label,
    caption: prefilledValues,
  }
}

type SelectedOption = {
  label?: string
  caption?: string
}

export const buildAddressFromResolvedPlace = (
  resolvedPlace: ResolvedPlace,
  selectedOption?: SelectedOption | null
) => {
  const addressParts: string[] = []
  if (resolvedPlace?.street_number) addressParts.push(resolvedPlace.street_number)
  if (resolvedPlace?.locality) addressParts.push(resolvedPlace.locality)

  const regionParts: string[] = []
  if (resolvedPlace?.admin_area_iso_code) {
    const province =
      resolvedPlace.admin_area_iso_code.split('-')[1] || resolvedPlace.admin_area_iso_code
    regionParts.push(province)
  }
  if (resolvedPlace?.postal_code) regionParts.push(resolvedPlace.postal_code)
  if (regionParts.length > 0) addressParts.push(regionParts.join(' '))

  if (resolvedPlace?.admin_area_iso_code) {
    const country = resolvedPlace.admin_area_iso_code.split('-')[0]
    addressParts.push(country)
  }

  if (selectedOption?.label && selectedOption?.caption) {
    return `${selectedOption.label}, ${selectedOption.caption}`
  }

  const fullAddress = addressParts.join(', ')
  return (
    selectedOption?.caption || selectedOption?.label || fullAddress || resolvedPlace?.name || ''
  )
}
